import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

/** Diálogo de cadastro/renomeação de cardápio. */
const CardapioForm = ({ cardapio, onClose, onSave, isSaving }) => {
  const [descricao, setDescricao] = useState("");

  useEffect(() => {
    if (cardapio) setDescricao(cardapio.descricao ?? "");
  }, [cardapio]);

  const podeSalvar = descricao.trim() !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...cardapio, descricao: descricao.trim() });
  };

  return (
    <Dialog open={Boolean(cardapio)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{cardapio?.codigo ? "Renomear Cardápio" : "Novo Cardápio"}</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            fullWidth
            required
            autoFocus
            margin="dense"
            label="Descrição"
            placeholder="Ex.: Cardápio 1º semestre"
            value={descricao}
            onChange={(event) => setDescricao(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CardapioForm;
